import * as React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import MinutesToText from 'modules/attendance/components/MinutesToText'

import PlannedHoursBreakdown from './Tooltips/PlannedHoursBreakdown'
import PlannedHoursTag from './Tooltips/PlannedHoursTag'

interface PlannedHoursProps {
  estimatedMinutes: number
  estimatedRegularMinutes: number
  estimatedOvertimeMinutes: number
  balanceFromPlanning: number
  rangeIncludesToday: boolean
}

const PlannedHours = ({
  estimatedMinutes,
  estimatedRegularMinutes,
  estimatedOvertimeMinutes,
  balanceFromPlanning,
  rangeIncludesToday,
}: PlannedHoursProps) => {
  return (
    <Box flexDirection="row" gap="s2" flexGrow>
      <Icon.Medium color="grey1000" icon="shift-management" />
      <Box gap="s2">
        <Box flexDirection="row" gap="s8" alignItems="baseline">
          <Box flexDirection="row" gap="s2" alignItems="center">
            <Text size="300" color="grey1000" weight="medium">
              {i18n.t('clock_in.bank_of_hours.counters.planned_hours.title')}
            </Text>
            {estimatedOvertimeMinutes > 0 && (
              <PlannedHoursBreakdown
                estimatedMinutes={estimatedMinutes}
                estimatedRegularMinutes={estimatedRegularMinutes}
                estimatedOvertimeMinutes={estimatedOvertimeMinutes}
              />
            )}
          </Box>
          {rangeIncludesToday && (
            <Text size="100">
              {i18n.t('clock_in.bank_of_hours.counters.until_today').toLowerCase()}
            </Text>
          )}
        </Box>
        <Box flexDirection="row" gap="s8">
          <MinutesToText color="grey1000" value={estimatedMinutes} size="500" weight="medium" />
          {balanceFromPlanning !== 0 && (
            <PlannedHoursTag
              balanceFromPlanning={balanceFromPlanning}
              estimatedOvertimeMinutes={estimatedOvertimeMinutes}
            />
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default PlannedHours
